import {
  mailboxesOauthOutlookCreateMutation,
  ReturnOutlookMailboxWritable
} from '@crm/api'
import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { paths } from '@crm/routes'
import { useQueryParams } from '@shared/hooks'
import { useMutation } from '@tanstack/react-query'
import { useEffect } from 'react'

export const NomenclaturesMailboxAuth = () => {
  const params = useQueryParams()

  const navigate = useAppNavigate()

  const { mutate } = useMutation({
    ...mailboxesOauthOutlookCreateMutation(),
    onError: () => navigate(paths.admin.nomenclatures.general.mailboxes),
    onSuccess: () => navigate(paths.admin.nomenclatures.general.mailboxes)
  })

  useEffect(() => {
    if (!params) return

    if (Object.keys(params).length === 0) {
      navigate(paths.admin.nomenclatures.general.mailboxes)
    }
    mutate({ body: params as ReturnOutlookMailboxWritable })
  }, [params])

  return 'Working...'
}
